import { Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './pages/painel/Login';
import PainelApp from './pages/painel/layout/PainelApp';
import Landing from './pages/landing/Landing';
import Privacidade from './pages/Privacidade';

function RequireAuth({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen grid place-items-center text-sm text-[var(--text-dim)]">
        Carregando...
      </div>
    );
  }
  if (!user) return <Navigate to="/painel/login" replace />;
  return <>{children}</>;
}

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/privacidade" element={<Privacidade />} />
        <Route path="/painel/login" element={<Login />} />
        <Route path="/painel/*" element={<RequireAuth><PainelApp /></RequireAuth>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthProvider>
  );
}
